// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OIbWk","home":"Header_home__WYvhg"};